import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { PureButton } from '../../basics';
import styles from './SwiffySlider.module.scss';
const Indicators = forwardRef(({ currentIndex, onSlideTo, size }, ref) => {
    const indicatorId = useId();
    return (_jsx("div", { className: styles.sliderIndicators, ref: ref, children: [...Array.from({ length: size }).keys()].map((_, index) => (_jsx(PureButton, { "aria-label": `Slide ${index}`, "data-active": index === currentIndex ? true : undefined, onClick: () => onSlideTo(index) }, `${indicatorId}-${index}`))) }));
});
Indicators.displayName = Indicators.name;
export { Indicators };
